import React from "react";
import GoogleStackedBarChart from "../../../../../components/googleChart/googleChart";
import PropTypes from "prop-types";

const RevenueFirstVisitChart = ({
  params: { data_table: { cols = [], rows = [] } = {}, options } = {},
  chartName,
  chartType = "Table",
  fixedCols,
  isTableView = undefined
}) => {
  return (
    <GoogleStackedBarChart
      chartName={chartName}
      width="1350px"
      height="400px"
      rows={rows}
      chartType={chartType}
      columns={cols}
      isTableView={isTableView}
      options={fixedCols ? { showRowNumber: false, frozenColumns: 1 } : options}
      enableEventListeners={true}
      showCurrency={false}
      showAdditionTooltip={false}
    />
  );
};

export default RevenueFirstVisitChart;

RevenueFirstVisitChart.propTypes = {
  params: PropTypes.object.isRequired,
  chartName: PropTypes.string.isRequired,
  fixedCols: PropTypes.bool,
  isTableView: PropTypes.bool
};
